module.exports = __webpack_public_path__ + "img/horizontal_3_6_5.af5d647c.png";